import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { InputQuantity } from './ItemQuantity.styles';
import { setSelectedItemsQuantity } from '../../../../../../../../../../../actions/tools/OrdersSearchActions';

const ItemQuantity = ({ itemId, itemQuantity, isDisabled }) => {
  const dispatch = useDispatch();

  const [value, setValue] = useState(itemQuantity);

  const handleChange = (e) => {
    const quantity = e.target.valueAsNumber;
    setValue(quantity);
    dispatch(setSelectedItemsQuantity(itemId, quantity));
  };

  return (
    <InputQuantity
      min={1}
      max={itemQuantity}
      value={value}
      id={'itemQuantity'}
      onChange={handleChange}
      onKeyDown={(e) => e.preventDefault()}
      disabled={isDisabled}
    />
  );
};

export default ItemQuantity;
